import template from './menu.html'

const menuComponent = (params) => {
    return {
        async init() {
            this.$nextTick(() => {
                this.$el.innerHTML = template
            })
        },
        goCinema() {
            this.app.showMenu = false
            this.app.goPage('cinema', true)
        },
        goCinema2() {
            this.app.showMenu = false
            this.app.goPage('cinema2', true)
        },
        goDevices() {
            this.app.showMenu = false
            this.app.goPage('devices', true)
        },
        goSupport() {
            //this.callIOS('goPage', {page: 'pages/fbmessages/index'})
            this.app.showMenu = false
            this.app.goPage('message')
        },
        goAbout() {
            this.app.showMenu = false
            this.app.goPage('about')
        },
        goChangePassword() {
            this.app.showMenu = false
            this.app.goPage('changePassword')
        },
        goSettings() {
            this.app.showMenu = false
            this.app.goPage('settings')
        },
        async onLogout() {
            if (! await this.callIOS('confirm', {message:'Выйти из профиля?'})) return
            this.app.logout()
            this.app.showMenu = false
        }
    }
}

export { menuComponent }